import { User } from "@interfaces/User";
import { Exclude, Expose } from "class-transformer";

@Exclude()
export class CreateUserDto {
    @Expose()
    readonly email: string;

    @Expose()
    readonly username: string;

    @Expose()
    readonly password: string;

    @Expose()
    readonly first_name: string;

    @Expose()
    readonly last_name: string;

    @Expose()
    readonly gender?: User["gender"];

    @Expose()
    readonly phone: string;

    @Expose()
    readonly loyalty_card: string;

    @Expose()
    readonly birthday: string;
}
